import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppForm from 'src/components/form/add-category/AppForm'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'
import ActionButtonFormSecond from 'src/components/form/general-input-form/ActionButtonFormSecond'

// helpers
import Axios from 'src/helpers/axios'

const EditCategory = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [category, setCategory] = useState('')
  const [openFilePreview, setOpenFilePreview] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchCategoryDetails()
  }, [id]);

  const fetchCategoryDetails = () => {
    Axios({
      method: "get",
      url: `/api/booking/v1/categories/id/${id}`,
    })
      .then(({ data }) => {
        setCategory(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const formik = useFormik({
    initialValues: {
      category_name: category.name,
      category_desc: category.description,
      category_images: category.image_url && category.image_url !== '' ? [category.image_url] : []
    },
    validationSchema: Yup.object().shape({
      category_name: Yup.string().required("Please enter category name.")
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    const formData = new FormData()

    formData.append('name', values.category_name)
    if (values.category_images.length > 0 && typeof values.category_images[0] !== "string") {
      formData.append('file', values.category_images[0])
    }
    if (values.category_desc !== '') {
      formData.append('description', values.category_desc)
    }

    return formData
  }

  const handleEdit = (payload) => {
    setIsLoading(true)
    Axios({
      method: "post",
      url: `/api/booking/v1/categories/update/${id}`,
      data: payload
    })
      .then(({ data }) => {
        navigate('/category/list')
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false))
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handleEdit(inputPayload)
  }

  const handleRemoveImage = (file) => {
    formik.setValues((values) => ({
      ...values,
      category_images: values.category_images.filter(image => image !== file)
    }), false)
  }

  const handleImagesOnDrop = (files) => {
    const attachments = []
    if (files[0] && typeof files[0] !== 'undefined') {
      attachments.push(files[0])
      formik.setValues((values) => ({
        ...values,
        category_images: attachments
      }), false)
    }
  }

  const handleImageAttachment = (e) => {
    e.preventDefault()
    const files = e.target.files
    const attachments = []
    if (files[0] && typeof files[0] !== 'undefined') {
      attachments.push(files[0])
      formik.setValues((values) => ({
        ...values,
        category_images: attachments
      }), false)
    }
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      <AppCard
        className='mb-4'
        headerTitle={<h4>Edit Category</h4>}
        bodyContent={
          <AppForm
            editPage
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            handleRemoveImage={handleRemoveImage}
            handleChangeImage={handleImageAttachment}
            handleFileInput={handleImageAttachment}
            handleFileOnDrop={handleImagesOnDrop}
            setOpenFilePreview={setOpenFilePreview}
          />
        }
        footerContent={
          <ActionButtonFormSecond
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate('/category/list')}
            onSave={() => formik.handleSubmit()}
          />
        }
      />
    </>
  )
}

export default EditCategory
